(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('FreightPaymentGridDTO', FreightPaymentGridDTO);

    FreightPaymentGridDTO.$inject = ['$resource','DateUtils'];

    function FreightPaymentGridDTO($resource, DateUtils) {
        var resourceUrl = "api/freightPaymentGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                    }
                    return data;
                }
            }
        });
    }
})();
